import { Stack } from "@mui/material";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation, Outlet } from "react-router-dom";
import { TARIFF_PATHS, ORDER_PATHS, ERROR_PATHS } from "src/consts/paths";
import HorizontalLinearProgressBar from "../ProgressBar/HorizontalLinearProgressBar";
import SplineScene, { Animations } from "../Spline/Spline";
import { tariffCalculator } from "../TariffCalculatorProgressBar/TariffCalculatorProgressBar";
import SplinePage from "../Layout/SplinePage";
import { useTranslation } from "react-i18next";
import { ROUTES } from "src/consts/routes";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";

export interface GlobalContextProps {
  setAnimations: Dispatch<SetStateAction<Animations>>;
}
const GlobalContext = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [splineUrl, setSpineUrl] = useState("");
  const [animations, setAnimations] = useState<Animations>({});

  const themeName = useContext(ThemeContext);

  useEffect(() => {
    if (themeName === ThemeValues.SMA) {
      setSpineUrl(
        "https://prod.spline.design/7kSHs5s-J87PzR4h/scene.splinecode"
      );
    } else {
      setSpineUrl(
        "https://prod.spline.design/A3wqZPUTYwU43bey/scene.splinecode"
      );
    }
  }, [themeName]);

  return (
    <>
      {TARIFF_PATHS.includes(pathname) && (
        <SplinePage
          pageTitle={
            pathname === ROUTES.CALCULATED_SAVINGS || pathname === ROUTES.TARIF
              ? ""
              : t("globalContext.pageTitle")
          }
          pageSubTitle={
            pathname === ROUTES.CALCULATED_SAVINGS || pathname === ROUTES.TARIF
              ? ""
              : t("globalContext.pageSubtitle")
          }
        >
          {pathname === ROUTES.TARIF ? (
            <></>
          ) : (
            <Stack>
              <SplineScene animations={animations} splineUrl={splineUrl} />
            </Stack>
          )}

          {pathname !== ROUTES.CALCULATED_SAVINGS &&
            pathname !== ROUTES.TARIF && (
              <Stack
                sx={{
                  display: { xs: "default", sm: "none" },
                  px: 4,
                  py: 4,
                }}
              >
                <HorizontalLinearProgressBar
                  variant="determinate"
                  value={tariffCalculator(pathname)}
                />
              </Stack>
            )}
          <Outlet context={{ setAnimations }} />
        </SplinePage>
      )}
      {ORDER_PATHS.includes(pathname) && <Outlet />}
      {ERROR_PATHS.includes(pathname) && <Outlet />}
    </>
  );
};

export default GlobalContext;
